import { system } from '../config/system'

export const resolveApiUrl = (url: string) => {
  return normalizeUrl(system.api.baseURL, url)
}

/**
 * 判断 url 是否是外部路径
 */
export const isExternalUrl = (() => {
  const regexp = /^\S+?:\/\//
  return (url?: string) => url && regexp.test(url)
})()

/**
 * 判断 url 是否是 http(s) 协议
 */
export const isHttpUrl = (() => {
  const regexp = /\s*https?:\/\//
  return (url?: string) => !!url && regexp.test(url)
})()

/**
 * 把多个 path 合并成标准的 url 路径
 *
 * @param args 多个 path 路径
 * @returns 格式化的 url
 */
export const normalizeUrl = (...args: string[]) => {
  let baseIndex = 0
  for (let i = args.length - 1; i >= 0; i--) {
    if (isExternalUrl(args[i])) {
      baseIndex = i
      break
    }
  }
  const url = args.slice(baseIndex).join('/')
  const parts = url.split('://')
  const schema = parts.length === 1 ? '' : parts[0] + '://'
  const path = parts.length === 1 ? parts[0] : parts[1]
  return schema + path.replace(/\/+/g, '/')
}
